import { render, staticRenderFns } from "./VSliderCourses.vue?vue&type=template&id=b98eaca0&"
import script from "./VSliderCourses.vue?vue&type=script&lang=js&"
export * from "./VSliderCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b98eaca0')) {
      api.createRecord('b98eaca0', component.options)
    } else {
      api.reload('b98eaca0', component.options)
    }
    module.hot.accept("./VSliderCourses.vue?vue&type=template&id=b98eaca0&", function () {
      api.rerender('b98eaca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VSliderCourses/VSliderCourses.vue"
export default component.exports